<template>
  <div class="container mx-auto">
    <h2 class="font-semibold text-lg m-2 px-2 mx-auto">Vytvoriť nového distribútora / predajcu</h2>
    <form @submit.prevent="onSubmit" class="grid grid-cols-1 md:grid-cols-2 gap-4 mx-2 p-4 bg-gray-200 rounded-md">
      <div>
        <label class="block text-left" for="storeName">Názov predajne (povinné)</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="text"
          name="storeName"
          v-model="form.store_name"
          required
        />
      </div>
      <div>
        <label class="block text-left" for="storeAddress">Adresa predajne</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="text"
          name="storeAddress"
          v-model="form.store_address"
        />
      </div>
      <div>
        <label class="block text-left" for="city">Mesto</label>
        <input class="block px-4 py-3 w-full text-left rounded-md" type="text" name="city" v-model="form.city" />
      </div>
      <div>
        <label class="block text-left" for="billingAddress">Fakturačná adresa</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="text"
          name="billingAddress"
          v-model="form.billing_address"
        />
      </div>
      <div>
        <label class="block text-left" for="ownerName">Meno / Vlastnik</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="text"
          name="ownerName"
          v-model="form.owner_name"
        />
      </div>
      <div>
        <label class="block text-left" for="email">Email</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="text"
          name="email"
          v-model="form.owner_email"
        />
      </div>
      <div>
        <label class="block text-left" for="phone">Telefón</label>
        <input class="block px-4 py-3 w-full text-left rounded-md" type="text" name="phone" v-model="form.phone" />
      </div>
      <div>
        <label class="block text-left" for="country">Krajina (povinné)</label>
        <select class="block px-4 py-3 w-full text-left rounded-md" name="country" v-model="form.country" required>
          <option value="">Select Country</option>
          <option value="sk">Slovensko</option>
          <option value="cz">Česko</option>
          <option value="mr">Morava</option>
        </select>
      </div>

      <div class="self-end">
        <button class="bg-green-400 hover:bg-green-500 rounded-md text-white font-semibold px-4 py-3" @click="update">
          Aktualizovať
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { onMounted, reactive } from "vue";
import { getDistributor, updateDistributor } from "../firebase";

export default {
  name: "Edit",
  setup() {
    // Accessing route parameters
    const router = useRouter();
    const route = useRoute();
    const distributorId = route.params.id;

    // Data container for template above
    const form = reactive({
      store_name: "",
      store_address: "",
      owner_name: "",
      owner_email: "",
      phone: "",
      city: "",
      billing_address: "",
      country: "",
    });

    // Get distributor data from DB
    onMounted(async () => {
      const distributor = await getDistributor(distributorId);
      form.store_name = distributor.store_name;
      form.store_address = distributor.store_address;
      form.owner_name = distributor.owner_name;
      form.owner_email = distributor.owner_email;
      form.phone = distributor.phone;
      form.city = distributor.city;
      form.billing_address = distributor.billing_address;
      form.country = distributor.country;
    });

    // Update function
    const update = async () => {
      await updateDistributor(distributorId, { ...form });
      router.push("/admin");
    };

    return { form, update };
  },
};
</script>
